import { createReducer, on } from '@ngrx/store';
import {
  createFormGroupState,
  FormGroupState,
  onNgrxForms,
  setValue,
} from 'ngrx-forms';
import {
  clearReleaseEmailResult,
  sendReleaseEmailSuccess,
  setAllExceptionsAccess,
  setAllGlobalAdminsAccess,
  setHasUserGlobalAdminAccess,
  setUserConfig,
  setUserConfigIsEmailDisabled,
} from './global-settings.actions';
import { EmailToViewModel } from 'src/app/shared/models/autogenerated';

export interface UserConfigForm {
  isEmailDisabled: boolean;
}

export interface GlobalSettingsState {
  userConfigForm: FormGroupState<UserConfigForm>;
  hasUserGlobalAdminAccess: boolean;
  globalAdminsIds: string[] | null;
  exceptionsIds: string[] | null;
  releaseEmailResult: EmailToViewModel | null;
}

const GLOBAL_SETTINGS_USER_CONFIG_FORM_ID =
  'ADAP_GLOBAL_USER_CONFIG_SETTINGS_FORM';
const initialConfigFormState = createFormGroupState<UserConfigForm>(
  GLOBAL_SETTINGS_USER_CONFIG_FORM_ID,
  {
    isEmailDisabled: false,
  }
);

const initialState: GlobalSettingsState = {
  userConfigForm: initialConfigFormState,
  hasUserGlobalAdminAccess: false,
  globalAdminsIds: null,
  exceptionsIds: [],
  releaseEmailResult: null,
};

export const GlobalSettingsReducer = createReducer(
  initialState,
  onNgrxForms(),
  on(setUserConfig, (state, { userConfig }) => ({
    ...state,
    userConfigForm: createFormGroupState<UserConfigForm>(
      GLOBAL_SETTINGS_USER_CONFIG_FORM_ID,
      userConfig
    ),
  })),
  on(setUserConfigIsEmailDisabled, (state, { isEmailDisabled }) => ({
    ...state,
    userConfigForm: setValue(<UserConfigForm>{
      ...state.userConfigForm.value,
      isEmailDisabled,
    })(state.userConfigForm),
  })),
  on(setHasUserGlobalAdminAccess, (state, { hasUserGlobalAdminAccess }) => ({
    ...state,
    hasUserGlobalAdminAccess,
  })),
  on(setAllGlobalAdminsAccess, (state, { globalAdminsIds }) => ({
    ...state,
    globalAdminsIds,
  })),
  on(setAllExceptionsAccess, (state, { exceptionsIds }) => ({
    ...state,
    exceptionsIds,
  })),
  on(sendReleaseEmailSuccess, (state, { result }) => ({
    ...state,
    releaseEmailResult: result,
  })),
  on(clearReleaseEmailResult, (state) => ({
    ...state,
    releaseEmailResult: null,
  }))
);
